export default __webpack_public_path__ + "static/media/swissbeauty.0bdfb3f4.JPG";